const BTN_BURGER_LABEL = ['Open Navigation', 'Close Navigation']

export default BTN_BURGER_LABEL
